import { Spinner, SpinnerProps } from "./index";


export function SpinnerIcon(
  {
    size,
    theme
  }: {
    size?: SpinnerProps["size"],
    theme?: SpinnerProps["theme"]
  }
) {
  return ({ className }: { className?: string }) => <Spinner size={ size } theme={ theme } className={ className } />;
}
